import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const fetchAktualityConfig = async () => {
  try {
    const response = await axiosInstance.get("/api/config/aktuality");
    // očekává { aktualita: "...", aktualita_pdf: "url nebo null" }
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání aktuality."
    );
    return { success: false, status, message };
  }
};
